/**
 * JSON-LD 構造化データ用コンポーザブル
 * @see https://developers.google.com/search/docs/appearance/structured-data
 */

type JsonLdType = Record<string, unknown>

export function useJsonLd(data: JsonLdType | Ref<JsonLdType | null> | ComputedRef<JsonLdType | null>) {
  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: computed(() => {
          const resolved = unref(data)
          return resolved ? JSON.stringify(resolved) : ''
        }),
      },
    ],
  })
}
